import { SmartComponent } from "smart-component-js";

class CarouselContentComponent extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    this.element = element;
    this.init();
  }

  init() {
    console.log("CarouselContentComponent component initialized");

    const checkbox = this.element.querySelector("input[type='checkbox']");
    const infoElement = this.element.querySelector(".carousel-content__info");

    if (checkbox && infoElement) {
      checkbox.addEventListener("change", () => {
        if (checkbox.checked) {
          infoElement.style.display = "none";
        } else {
          infoElement.style.display = "flex";
        }
      });
    }
  }
}

export default CarouselContentComponent;
